export default __webpack_public_path__ + "static/media/PowerPoint.e7800c0d.png";